import { Box, Card, CardContent, Typography } from "@mui/material";

export default function OntimeHeader() {
    return (
        <Card variant="outlined">
            <CardContent>
                <Box display={"flex"} justifyContent={"space-between"}>
                    <Typography variant="h5" fontWeight={"bold"}>Ontime Status</Typography>
                </Box>
            </CardContent>
        </Card>
    )
}